import { onError } from '@apollo/client/link/error'
import { deleteCookie } from 'cookies-next'

const isBrowser = typeof window !== 'undefined'

/**
 * If there was a token it would send a request to the api. It can happen that the token was expired
 * and returns a 401 (unauthorized), if this happens we should remove the token.
 */
const unauthorizedLink = onError(({ networkError, operation, forward }) => {
  if (networkError) {
    const { statusCode } = networkError
    if (statusCode === 401) {
      const headers = operation.getContext().headers
      if (isBrowser) {
        deleteCookie(process.env.NEXT_PUBLIC_TOKEN_COOKIE_NAME)
      }

      operation.setContext({
        headers: {
          ...headers,
          Authorization: '',
        },
      })
    }
  }
  return forward(operation)
})

export default unauthorizedLink
